import React from 'react';
import { ArrowRight, Check, Shield, BookOpen, Users } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ServiceSubscription = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen text-white pt-20 md:pt-32">
      {/* Hero Section - Responsive */}
      <div className="container mx-auto px-4 mb-8 md:mb-16">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-block px-4 py-2 rounded-full bg-[#017D7E]/10 text-[#017D7E] mb-6 md:mb-8 text-sm md:text-base">
            Abonnement E-Learning
          </div>
          <h1 className="text-3xl md:text-5xl font-bold mb-4 md:mb-6">
            Accédez à Notre
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#017D7E] to-[#00A99D]">
              Catalogue de Formations
            </span>
          </h1>
          <p className="text-base md:text-xl text-white/70">
            Un abonnement flexible pour développer vos compétences en finance et technologie
          </p>
        </div>
      </div>

      {/* Pricing Section - Responsive */}
      <div className="container mx-auto px-4 mb-8 md:mb-16">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          <PriceCard
            title="Mensuel"
            price="49"
            period="/mois"
            features={[
              "Accès à tout le catalogue",
              "Support communautaire",
              "Certifications incluses",
              "Annulable à tout moment"
            ]}
            cta="Commencer"
            popular={false}
          />
          <PriceCard
            title="Annuel"
            price="399"
            period="/an"
            features={[
              "Économisez 189€",
              "Accès à tout le catalogue",
              "Support communautaire",
              "Certifications incluses",
              "1 session de mentorat"
            ]}
            cta="Meilleure offre"
            popular={true}
          />
          <PriceCard
            title="Entreprise"
            price="Sur mesure"
            period=""
            features={[
              "Portail entreprise dédié",
              "Suivi des collaborateurs",
              "Support dédié",
              "Formations personnalisées",
              "Facturation entreprise"
            ]}
            cta="Contacter commercial"
            popular={false}
          />
        </div>
      </div>

      {/* Features Grid - Responsive */}
      <div className="container mx-auto px-4 py-12 md:py-16 bg-white/5">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <FeatureCard
              icon={BookOpen}
              title="Catalogue Complet"
              description="Accédez à plus de 100 formations expertises"
            />
            <FeatureCard
              icon={Shield}
              title="Certifications"
              description="Validez vos compétences avec nos certificats"
            />
            <FeatureCard
              icon={Users}
              title="Communauté"
              description="Échangez avec d'autres apprenants"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

// Composant carte de prix responsive
const PriceCard = ({ title, price, period, features, cta, popular }) => (
  <div className={`relative bg-white/5 rounded-xl p-6 md:p-8 border ${popular ? 'border-green-500' : 'border-white/10'}`}>
    {popular && (
      <div className="absolute top-0 right-0 bg-[#017D7E] text-white text-sm font-semibold px-3 py-1 rounded-tr-xl rounded-bl-xl">
        Populaire
      </div>
    )}
    <h3 className="text-xl md:text-2xl font-bold mb-2">{title}</h3>
    <div className="mb-6">
      <span className="text-3xl md:text-4xl font-bold">{price}</span>
      <span className="text-sm md:text-base text-white/70">{period}</span>
    </div>
    <ul className="space-y-3 mb-8">
      {features.map((feature, index) => (
        <li key={index} className="flex items-center gap-2 text-white/70 text-sm md:text-base">
          <Check className="w-4 h-4 md:w-5 md:h-5 text-[#017D7E] flex-shrink-0" />
          {feature}
        </li>
      ))}
    </ul>
    <button className="w-full py-3 px-4 rounded-lg bg-gradient-to-r from-green-500 to-[#017D7E] hover:from-green-600 hover:to-emerald-600 text-white font-medium transition-all text-sm md:text-base">
      {cta}
    </button>
  </div>
);

// Composant carte de fonctionnalité responsive
const FeatureCard = ({ icon: Icon, title, description }) => (
  <div className="text-center">
    <div className="w-12 h-12 md:w-16 md:h-16 rounded-xl bg-[#017D7E]/10 flex items-center justify-center mx-auto mb-4 md:mb-6">
      <Icon className="w-6 h-6 md:w-8 md:h-8 text-[#017D7E]" />
    </div>
    <h3 className="text-lg md:text-xl font-bold mb-2 md:mb-4">{title}</h3>
    <p className="text-sm md:text-base text-white/70">{description}</p>
  </div>
);

export default ServiceSubscription;